function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M11.7678 0.73223C12.7441 1.70854 12.7441 3.29145 11.7678 4.26776C10.7915 5.24407 9.20854 5.24407 8.23223 4.26776C7.25592 3.29145 7.25592 1.70854 8.23223 0.73223C9.2085 -0.244077 10.7914 -0.244077 11.7678 0.73223Z",
  fill: "#6C6E70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.7678 8.23223C12.7441 9.20854 12.7441 10.7915 11.7678 11.7678C10.7915 12.7441 9.20854 12.7441 8.23223 11.7678C7.25592 10.7915 7.25592 9.20854 8.23223 8.23223C9.2085 7.25592 10.7914 7.25592 11.7678 8.23223Z",
  fill: "#6C6E70"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.7678 15.7322C12.7441 16.7085 12.7441 18.2915 11.7678 19.2678C10.7915 20.2441 9.20854 20.2441 8.23223 19.2678C7.25592 18.2915 7.25592 16.7085 8.23223 15.7322C9.2085 14.7559 10.7914 14.7559 11.7678 15.7322Z",
  fill: "#6C6E70"
}));

var SvgMenu = function SvgMenu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu.a8aa60ff.svg";
export { ForwardRef as ReactComponent };